// Internationalization translations
export const translations = {
  fr: {
    // Navigation
    dashboard: "Tableau de bord",
    schedule: "Planning",
    absences: "Congés / Absences",
    users: "Utilisateurs",
    team: "Mon Équipe",
    stats: "Statistiques",
    logout: "Déconnexion",
    
    // Login
    login: "Connexion",
    register: "Inscription",
    email: "Email",
    password: "Mot de passe",
    firstName: "Prénom",
    lastName: "Nom",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    noAccount: "Pas encore de compte ? S'inscrire",
    hasAccount: "Déjà un compte ? Se connecter",
    accessWorkspace: "à votre extranet collaborateur Vitalis - Sports",
    createAccount: "Créez votre compte pour commencer",
    loginSuccess: "Connexion réussie",
    
    // Dashboard
    welcomeBack: "Bienvenue",
    yourSummary: "Voici votre résumé",
    hoursThisWeek: "Heures cette semaine",
    hoursThisMonth: "Heures ce mois",
    pendingAbsences: "Absences en attente",
    approvedAbsences: "Absences approuvées",
    teamStats: "Statistiques équipe",
    teamMembers: "Membres de l'équipe",
    totalHoursMonth: "Heures totales (mois)",
    avgPerPerson: "Moyenne par personne",
    hoursPerCollaborator: "Heures par collaborateur (ce mois)",
    quickActions: "Actions rapides",
    viewSchedule: "Voir le planning",
    manageAbsences: "Gérer les absences",
    requestAbsence: "Demander une absence",
    
    // Schedule
    weekOf: "Semaine du",
    dayView: "Jour",
    weekView: "Semaine",
    monthView: "Mois",
    previousDay: "Jour précédent",
    nextDay: "Jour suivant",
    copyWeek: "Copier",
    allMembers: "Tous les membres",
    addSlot: "Ajouter un créneau",
    editSlot: "Modifier le créneau",
    slotAdded: "Créneau ajouté",
    slotUpdated: "Créneau mis à jour",
    slotDeleted: "Créneau supprimé",
    collaborator: "Collaborateur",
    date: "Date",
    startTime: "Début",
    endTime: "Fin",
    add: "Ajouter",
    update: "Mettre à jour",
    delete: "Supprimer",
    copySchedule: "Copier le planning",
    copyConfirm: "Copier le planning de la semaine actuelle vers la semaine suivante ?",
    source: "Source",
    destination: "Destination",
    cancel: "Annuler",
    confirm: "Confirmer",
    slotsCopied: "créneaux copiés",
    resizeSlot: "Redimensionner le créneau",
    addSlot: "Ajouter un créneau",
    
    // Time corrections
    actualHours: "Heures réelles",
    plannedHours: "Heures planifiées",
    difference: "Différence",
    pendingCorrections: "Corrections en attente",
    correctTime: "Corriger le temps",
    actualStartTime: "Heure début réelle",
    actualEndTime: "Heure fin réelle",
    correctionReason: "Motif de correction",
    submitCorrection: "Soumettre la correction",
    validateCorrection: "Valider la correction",
    rejectCorrection: "Rejeter la correction",
    correctionSubmitted: "Correction soumise",
    correctionValidated: "Correction validée",
    correctionRejected: "Correction rejetée",
    
    // Absences
    absenceRequests: "Demandes d'absence",
    myAbsences: "Mes absences",
    requestsPending: "demande(s) en attente",
    manageYourAbsences: "Gérez vos demandes d'absence",
    newRequest: "Nouvelle demande",
    noAbsences: "Aucune demande d'absence",
    type: "Type",
    period: "Période",
    reason: "Motif",
    status: "Statut",
    actions: "Actions",
    pending: "En attente",
    approved: "Approuvée",
    rejected: "Refusée",
    cancelled: "Annulée",
    cancel: "Annuler",
    requestCancelled: "Demande annulée",
    confirmCancelAbsence: "Êtes-vous sûr de vouloir annuler cette absence ?",
    cancelledByAdmin: "Annulé par l'administrateur",
    paidLeave: "Congé payé",
    sickLeave: "Maladie",
    unpaidLeave: "Sans solde",
    other: "Autre",
    newAbsenceRequest: "Nouvelle demande d'absence",
    absenceType: "Type d'absence",
    startDate: "Date de début",
    endDate: "Date de fin",
    reasonPlaceholder: "Décrivez le motif de votre absence...",
    submitRequest: "Envoyer la demande",
    requestCreated: "Demande d'absence créée",
    processRequest: "Traiter la demande",
    rejectionReason: "Motif du refus (optionnel)",
    rejectionPlaceholder: "Indiquez le motif si vous refusez...",
    approve: "Approuver",
    reject: "Refuser",
    requestApproved: "Demande approuvée",
    requestRejected: "Demande refusée",
    
    // Leave balance
    leaveBalance: "Solde de congés",
    leaveBalanceDescription: "Suivi des congés par collaborateur pour l'année en cours",
    annualLeave: "Congés annuels",
    usedLeave: "Utilisé",
    pendingLeave: "En attente",
    remainingLeave: "Restant",
    hoursAllocated: "Heures allouées",
    hoursUsed: "Heures utilisées",
    hoursPlanned: "Heures planifiées",
    hoursRemaining: "Heures restantes",
    daysAllocated: "Jours alloués",
    daysUsed: "Jours validés",
    daysPlanned: "Jours en attente de validation",
    daysRemaining: "Jours restants",
    totalAvailable: "Total disponible",
    noAllocationYet: "Aucune allocation de congés pour cette année. Cliquez sur 'Allouer des congés' pour en créer une.",
    allocateLeave: "Allouer des congés",
    year: "Année",
    week: "sem",
    allocatedHours: "Heures allouées",
    saveAllocation: "Enregistrer",
    allocationSaved: "Allocation enregistrée",
    refresh: "Actualiser",
    prevYearBalance: "Report année",
    prevYearCarryOver: "Reliquat Année -1",
    days: "j",
    lastAbsences: "5 derniers congés",
    nextAbsences: "5 prochains congés",
    noPlannedAbsences: "Aucun congé planifié",
    deductedFromPrevYear: "Déduit de N-1",
    fromN1: "dont N-1",
    
    forCollaborator: "Pour le collaborateur",
    forMyself: "Pour moi-même",
    
    // Users
    userManagement: "Gestion des utilisateurs",
    usersRegistered: "utilisateur(s) enregistré(s)",
    newUser: "Nouvel utilisateur",
    collaborators: "Collaborateurs",
    managers: "Managers",
    active: "Actifs",
    inactive: "Inactif",
    name: "Nom",
    role: "Rôle",
    director: "Directeur",
    manager: "Manager",
    editUser: "Modifier l'utilisateur",
    createUser: "Créer l'utilisateur",
    userCreated: "Utilisateur créé",
    userUpdated: "Utilisateur mis à jour",
    userDeleted: "Utilisateur supprimé",
    userActivated: "Utilisateur activé",
    userDeactivated: "Utilisateur désactivé",
    showInactiveUsers: "Afficher les utilisateurs inactifs",
    
    // Stats
    statistics: "Statistiques",
    teamPerformance: "Analyse des performances de l'équipe",
    thisWeek: "Cette semaine",
    thisMonth: "Ce mois",
    thisYear: "Cette année",
    workHoursSummary: "RÉCAPITULATIF DES HEURES",
    months3: "3 mois",
    months6: "6 mois",
    totalHours: "Heures totales",
    avgPerson: "Moy. / Personne",
    hoursByCollaborator: "Heures par collaborateur",
    distribution: "Répartition (Top 5)",
    detailByCollaborator: "Détail par collaborateur",
    hoursWorked: "Heures travaillées",
    daysWorked: "Jours travaillés",
    percentTotal: "% du total",
    noDataAvailable: "Aucune donnée disponible",
    verticalLayout: "Affichage vertical",
    horizontalLayout: "Affichage horizontal",
    
    // Totals
    weeklyTotal: "Total semaine",
    monthlyTotal: "Total mois",
    mondayToSunday: "Lundi - Dimanche",
    calendarMonth: "Mois calendaire",
    day: "Jour",
    
    // Events
    events: "Événements",
    newEvent: "Nouvel événement",
    eventTitle: "Titre",
    eventDescription: "Description",
    eventColor: "Couleur",
    allDay: "Journée entière",
    eventCreated: "Événement créé",
    eventUpdated: "Événement mis à jour",
    eventDeleted: "Événement supprimé",
    
    // Export
    exportPDF: "Exporter PDF",
    exportExcel: "Exporter Excel",
    exportSuccess: "Export téléchargé avec succès",
    exportError: "Erreur lors de l'export",
    pdfExported: "PDF exporté avec succès",
    
    // Holidays
    holiday: "Jour férié",
    
    // Password
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordChanged: "Mot de passe modifié",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordDescription: "Entrez votre email et nous vous enverrons un lien de réinitialisation.",
    sendResetLink: "Envoyer le lien",
    resetEmailSent: "Email envoyé",
    emailSent: "Email envoyé !",
    checkYourEmail: "Si un compte existe avec cette adresse, vous recevrez un email avec les instructions.",
    backToLogin: "Retour à la connexion",
    
    // Colors
    userColor: "Couleur",
    
    // Overtime
    overtime: "Heures supplémentaires",
    overtimeManagement: "Gestion des heures supplémentaires",
    addOvertime: "Ajouter des heures",
    overtimeHours: "Heures",
    overtimeReason: "Motif",
    overtimeDate: "Date",
    overtimeAdded: "Heures supplémentaires ajoutées",
    overtimeDeleted: "Entrée supprimée",
    totalOvertime: "Total heures sup.",
    noOvertimeEntries: "Aucune entrée d'heures supplémentaires",
    confirmDeleteOvertime: "Êtes-vous sûr de vouloir supprimer cette entrée ?",
    
    // Admin
    administration: "Administration",
    systemConfiguration: "Configuration du système",
    emailConfiguration: "Configuration email",
    brevoSmtpSettings: "Paramètres SMTP Brevo pour l'envoi d'emails",
    databaseConfiguration: "Configuration base de données",
    mysqlSettings: "Paramètres de connexion MySQL (OVH)",
    mysqlMigrationNote: "La migration vers MySQL sera effectuée une fois les paramètres configurés et validés.",
    smtpHost: "Serveur SMTP",
    smtpPort: "Port SMTP",
    smtpUser: "Utilisateur SMTP",
    smtpPassword: "Mot de passe SMTP",
    emailFrom: "Email expéditeur",
    mysqlHost: "Serveur MySQL",
    mysqlPort: "Port MySQL",
    mysqlDatabase: "Base de données",
    mysqlUser: "Utilisateur MySQL",
    mysqlPassword: "Mot de passe MySQL",
    configSaved: "Configuration enregistrée",
    testConnection: "Tester la connexion",
    emailTestSuccess: "Test email réussi",
    emailTestFailed: "Échec du test email",
    connected: "Connecté",
    failed: "Échec",
    testing: "Test en cours...",
    saving: "Enregistrement...",
    note: "Note",
    
    // User preferences
    defaultLanguage: "Langue par défaut",
    
    // Filter & Selection
    filter: "Filtrer",
    filters: "Filtres",
    selectCollaborators: "Sélectionner les collaborateurs",
    selectAll: "Tout",
    deselectAll: "Aucun",
    allCollaborators: "Tous les collaborateurs",
    you: "vous",
    more: "de plus",
    notAuthorized: "Non autorisé",
    
    // Work Hours & Holidays
    workHours: "Horaires",
    workHoursConfiguration: "Configuration des horaires",
    workHoursDescription: "Définissez les heures de début et fin de journée pour le planning",
    dayStartHour: "Heure de début",
    dayEndHour: "Heure de fin",
    workHoursNote: "Ces paramètres définissent la plage horaire affichée dans le planning.",
    holidayCountry: "Pays pour les jours fériés",
    selectCountry: "Sélectionner le pays",
    switzerland: "Suisse",
    france: "France",
    holidayCountryNote: "Les jours fériés seront affichés selon le pays sélectionné.",
    portalLanguage: "Langue du portail",
    defaultLanguage: "Langue par défaut",
    defaultDuration: "Durée par défaut",
    defaultDayDuration: "Durée journée",
    defaultBreakDuration: "Pause par défaut",
    breakThreshold: "Seuil pour pause",
    breakThresholdDesc: "Heures après lesquelles une pause est requise",
    hours: "heures",
    minutes: "minutes",
    
    // My Profile
    myProfile: "Mon Profil",
    changeOwnPassword: "Changer mon mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordChanged: "Mot de passe modifié avec succès",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    incorrectCurrentPassword: "Mot de passe actuel incorrect",
    
    // Email Test
    testEmailConnection: "Tester la connexion email",
    testEmailAddress: "Email de test",
    sendTestEmail: "Envoyer un test",
    sending: "Envoi...",
    enterTestEmail: "Entrez une adresse email de test",
    
    // Schedule extras
    breakMinutes: "Pause (minutes)",
    comment: "Commentaire",
    commentPlaceholder: "Commentaire optionnel...",
    netHours: "Heures nettes",
    break: "Pause",
    sourceWeek: "Semaine source",
    targetWeeks: "Semaines cibles",
    selectWeek: "Sélectionner une semaine",
    selected: "sélectionnées",
    selectTargetWeeks: "Sélectionnez au moins une semaine cible",
    editEvent: "Modifier l'événement",
    
    // Reporting Planning
    reportingPlanning: "Reporting Planning",
    reportYourHours: "Déclarez vos heures travaillées",
    reportHours: "Déclarer mes heures",
    archived: "Archivées",
    validatedWeeks: "Semaines validées",
    noArchivedWeeks: "Aucune semaine archivée",
    weekValidated: "Cette semaine a été validée",
    weekPendingValidation: "En attente de validation par votre manager",
    weekRejected: "Cette semaine a été rejetée",
    selectPastWeek: "Sélectionnez une semaine passée pour déclarer vos heures",
    noScheduleForWeek: "Aucun planning pour cette semaine",
    editHours: "Modifier",
    modified: "Modifié",
    unchanged: "Inchangé",
    submitForValidation: "Soumettre pour validation",
    weekSubmitted: "Semaine soumise pour validation",
    hoursSaved: "Heures enregistrées",
    editActualHours: "Modifier les heures effectuées",
    optionalComment: "Commentaire optionnel (retard, imprévu...)",
    pendingValidations: "Validations en attente",
    allReports: "Tous les rapports",
    noPendingValidations: "Aucune validation en attente",
    modifiedSlots: "Créneaux modifiés",
    approve: "Valider",
    reject: "Rejeter",
    reportApproved: "Rapport validé",
    reportRejected: "Rapport rejeté",
    filters: "Filtres",
    allStatuses: "Tous les statuts",
    allCollaborators: "Tous les collaborateurs",
    allDates: "Toutes les dates",
    clearDate: "Effacer",
    noReportsFound: "Aucun rapport trouvé",
    submittedOn: "Soumis le",
    validatedOn: "Validé le",
    validated: "Validée",
    
    // Working days calculation
    numberOfDays: "Nb jours",
    effectiveDeduction: "Temps effectif décompté",
    calendarDays: "Jours calendaires",
    workingDays: "Jours ouvrés",
    realDays: "Jours réels",
    deductedDays: "Jours décomptés",
    days: "jour(s)",
    calculating: "Calcul en cours",
    excludedDaysInfo: "Exclus : {{weekends}} week-end(s), {{holidays}} jour(s) férié(s)",
    
    // Multi-select
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner", 
    clearSelection: "Effacer la sélection",
    
    // Contractual Hours & Stats
    weeklyContractualHours: "Heures contractuelles/semaine",
    weeklyContractualHoursRequired: "Les heures contractuelles hebdomadaires sont obligatoires",
    requiredField: "Champ obligatoire",
    contractualHours: "Heures contractuelles",
    actualVsContractual: "Heures travaillées vs. contractuelles",
    variance: "Écart",
    overtime: "Heures supplémentaires",
    undertime: "Heures manquantes",
    sickDays: "Jours maladie",
    sickDaysUsed: "Jours maladie utilisés",
    sickDaysRemaining: "Jours maladie restants",
    
    // Dashboard Widget Preferences
    dashboardWidgets: "Widgets du tableau de bord",
    showWeather: "Afficher météo",
    showNewsAltstaetten: "Afficher news Altstätten",
    showTennis: "Afficher news tennis",
    
    // Default Leave Days
    defaultLeaveDays: "Jours de congés par défaut",
    
    // Leave Admin
    leaveManagement: "Gestion des congés",
    carryoverTitle: "Basculer les reliquats",
    carryoverDescription: "Transférer les jours restants de l'année source vers le reliquat de l'année cible.",
    carryoverButton: "Basculer les jours restants en reliquat",
    confirmCarryover: "Voulez-vous transférer les jours restants de {{source}} vers le reliquat {{target}} pour tous les utilisateurs ?",
    resetQuotasTitle: "Réaffecter les quotas",
    resetQuotasDescription: "Réinitialiser les quotas de congés selon les jours par défaut de chaque utilisateur.",
    resetQuotasButton: "Réaffecter les quotas par défaut",
    resetQuotasInfo: "Cette action créera ou mettra à jour les allocations de congés pour tous les utilisateurs actifs, en utilisant leur nombre de jours de congés par défaut.",
    confirmResetQuotas: "Voulez-vous réaffecter les quotas par défaut pour l'année {{year}} à tous les utilisateurs ?",
    sourceYear: "Année source",
    targetYear: "Année cible",
    totalUsers: "Utilisateurs total",
    usersWithAllocation: "Avec allocation",
    usersWithoutAllocation: "Sans allocation",
    leaveAllocationSummary: "Résumé des allocations",
    defaultDays: "Jours défaut",
    annualDays: "Jours annuels",
    carryoverDays: "Reliquat N-1",
    totalDays: "Total jours",
    
    // Day part for absences
    dayPart: "Période de la journée",
    morning: "Matin",
    afternoon: "Après-midi",
    fullDay: "Journée entière",
    
    // Profile
    chooseLanguage: "Choisir ma langue",
    languageChanged: "Langue modifiée",
    languageNote: "La langue choisie sera utilisée pour l'interface et les exports PDF.",
    passwordMinLength: "Minimum 6 caractères",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    
    // Version
    version: "Version",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    save: "Enregistrer",
    close: "Fermer",
    edit: "Modifier",
    hour: "Heure",
    hours: "heures",
    h: "h",
    days: "jours",
    day: "jour",
    week: "Semaine",
    month: "Mois",
    monday: "Lun",
    tuesday: "Mar",
    wednesday: "Mer",
    thursday: "Jeu",
    friday: "Ven",
    saturday: "Sam",
    sunday: "Dim",
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",
    
    // Team Communication
    teamCommunication: "Communication équipe",
    sendMessageToTeam: "Envoyez un message à votre équipe",
    recipients: "Destinataires",
    selectAllTeam: "Toute l'équipe",
    recipientsSelected: "destinataire(s) sélectionné(s)",
    subject: "Objet",
    enterSubject: "Entrez l'objet du message",
    message: "Message",
    enterMessage: "Rédigez votre message...",
    attachPlanningPDF: "Joindre le planning en PDF",
    planningDuration: "Durée du planning",
    week: "semaine",
    weeks: "semaines",
    sendMessage: "Envoyer le message",
    sending: "Envoi en cours",
    messageSentTo: "Message envoyé à",
    selectAtLeastOneRecipient: "Sélectionnez au moins un destinataire",
    subjectRequired: "L'objet est requis",
    messageRequired: "Le message est requis",
    sendError: "Erreur lors de l'envoi",
    messageHistory: "Historique des messages",
    noMessagesSent: "Aucun message envoyé",
    failed: "échec(s)",
    dragToMove: "Glisser pour déplacer",
    
    // Navigation extras
    publicSite: "Site public",
    help: "Aide",
    
    // Error Log & Version
    errorLog: "Journal des erreurs",
    hideResolved: "Masquer résolus",
    showResolved: "Afficher résolus",
    resolveAll: "Tout résoudre",
    clearAll: "Effacer tout",
    noErrors: "Aucune erreur",
    version: "Version",
    
    // Schedule Period Selector
    displayPeriod: "Afficher",
    weeksFrom: "semaine(s) à partir du",
    monthsFrom: "mois à partir du",
    today: "Aujourd'hui",
    
    // Daily Planning Validation
    validateMyPlanning: "Valider mon planning",
    dailyValidation: "Validation quotidienne",
    pendingValidationDays: "jours en attente de validation",
    noValidationPending: "Aucun jour en attente de validation",
    conformSchedule: "Planning conforme",
    nonConformSchedule: "Proposer une modification",
    validateDay: "Valider",
    validateAll: "Tout valider",
    modifySchedule: "Modifier",
    effectiveTime: "Temps effectif",
    modificationReason: "Motif de modification",
    reasonRequired: "Le motif est obligatoire",
    submitModification: "Soumettre la modification",
    modificationSubmitted: "Modification soumise",
    validationHistory: "Historique des validations",
    noValidationHistory: "Aucun historique",
    modificationApproved: "Approuvée",
    modificationRejected: "Rejetée",
    modificationPending: "En attente",
    dayValidated: "Jour validé",
    allDaysValidated: "Tous les jours ont été validés",
    proposedStart: "Début proposé",
    proposedEnd: "Fin proposée",
    proposedBreak: "Pause proposée",
    
    // Manager Planning Validation
    collaboratorsToValidate: "Collaborateurs à valider",
    collaboratorsWithPendingDays: "Collaborateurs ayant plus de 2 jours à valider",
    planningValidation: "Validation du planning",
    daysToValidate: "jours",
    stateFilter: "État",
    toValidate: "À valider",
    modifiedState: "Modifié",
    notModifiedState: "Non modifié",
    allStates: "Tous les états",
    dateRange: "Période",
    fromDate: "Du",
    toDate: "Au",
    originalPlanning: "Planning original",
    proposedModification: "Modification proposée",
    approveModification: "Approuver",
    rejectModification: "Rejeter",
    modificationApprovedSuccess: "Modification approuvée et appliquée au planning",
    modificationRejectedSuccess: "Modification rejetée",
    noValidationsToReview: "Aucune validation en attente",
    scheduleModified: "Modifié",
  },
  
  en: {
    // Navigation
    dashboard: "Dashboard",
    schedule: "Schedule",
    absences: "Leave / Absences",
    users: "Users",
    team: "My Team",
    stats: "Statistics",
    logout: "Logout",
    
    // Login
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    firstName: "First Name",
    lastName: "Last Name",
    signIn: "Sign In",
    signUp: "Sign Up",
    noAccount: "Don't have an account? Sign up",
    hasAccount: "Already have an account? Sign in",
    accessWorkspace: "to your Vitalis - Sports employee extranet",
    createAccount: "Create your account to get started",
    loginSuccess: "Login successful",
    
    // Dashboard
    welcomeBack: "Welcome",
    yourSummary: "Here is your summary",
    hoursThisWeek: "Hours this week",
    hoursThisMonth: "Hours this month",
    pendingAbsences: "Pending absences",
    approvedAbsences: "Approved absences",
    teamStats: "Team statistics",
    teamMembers: "Team members",
    totalHoursMonth: "Total hours (month)",
    avgPerPerson: "Average per person",
    hoursPerCollaborator: "Hours per collaborator (this month)",
    quickActions: "Quick actions",
    viewSchedule: "View schedule",
    manageAbsences: "Manage absences",
    requestAbsence: "Request absence",
    
    // Schedule
    weekOf: "Week of",
    dayView: "Day",
    weekView: "Week",
    monthView: "Month",
    previousDay: "Previous day",
    nextDay: "Next day",
    copyWeek: "Copy",
    allMembers: "All members",
    addSlot: "Add slot",
    editSlot: "Edit slot",
    slotAdded: "Slot added",
    slotUpdated: "Slot updated",
    slotDeleted: "Slot deleted",
    collaborator: "Collaborator",
    date: "Date",
    startTime: "Start",
    endTime: "End",
    add: "Add",
    update: "Update",
    delete: "Delete",
    copySchedule: "Copy schedule",
    copyConfirm: "Copy current week schedule to next week?",
    source: "Source",
    destination: "Destination",
    cancel: "Cancel",
    confirm: "Confirm",
    slotsCopied: "slots copied",
    resizeSlot: "Resize slot",
    addSlot: "Add slot",
    
    // Time corrections
    actualHours: "Actual hours",
    plannedHours: "Planned hours",
    difference: "Difference",
    pendingCorrections: "Pending corrections",
    correctTime: "Correct time",
    actualStartTime: "Actual start time",
    actualEndTime: "Actual end time",
    correctionReason: "Correction reason",
    submitCorrection: "Submit correction",
    validateCorrection: "Validate correction",
    rejectCorrection: "Reject correction",
    correctionSubmitted: "Correction submitted",
    correctionValidated: "Correction validated",
    correctionRejected: "Correction rejected",
    
    // Absences
    absenceRequests: "Absence requests",
    myAbsences: "My absences",
    requestsPending: "pending request(s)",
    manageYourAbsences: "Manage your absence requests",
    newRequest: "New request",
    noAbsences: "No absence requests",
    type: "Type",
    period: "Period",
    reason: "Reason",
    status: "Status",
    actions: "Actions",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
    cancel: "Cancel",
    requestCancelled: "Request cancelled",
    confirmCancelAbsence: "Are you sure you want to cancel this absence?",
    cancelledByAdmin: "Cancelled by administrator",
    paidLeave: "Paid leave",
    sickLeave: "Sick leave",
    unpaidLeave: "Unpaid leave",
    other: "Other",
    newAbsenceRequest: "New absence request",
    absenceType: "Absence type",
    startDate: "Start date",
    endDate: "End date",
    reasonPlaceholder: "Describe the reason for your absence...",
    submitRequest: "Submit request",
    requestCreated: "Absence request created",
    processRequest: "Process request",
    rejectionReason: "Rejection reason (optional)",
    rejectionPlaceholder: "Enter reason if rejecting...",
    approve: "Approve",
    reject: "Reject",
    requestApproved: "Request approved",
    requestRejected: "Request rejected",
    
    // Leave balance
    leaveBalance: "Leave balance",
    leaveBalanceDescription: "Leave tracking by collaborator for the current year",
    annualLeave: "Annual leave",
    usedLeave: "Used",
    pendingLeave: "Pending",
    remainingLeave: "Remaining",
    hoursAllocated: "Hours allocated",
    hoursUsed: "Hours used",
    hoursPlanned: "Hours planned",
    hoursRemaining: "Hours remaining",
    daysAllocated: "Days allocated",
    daysUsed: "Days validated",
    daysPlanned: "Days pending validation",
    daysRemaining: "Days remaining",
    totalAvailable: "Total available",
    noAllocationYet: "No leave allocation for this year. Click 'Allocate leave' to create one.",
    allocateLeave: "Allocate leave",
    year: "Year",
    week: "wk",
    allocatedHours: "Allocated hours",
    saveAllocation: "Save",
    allocationSaved: "Allocation saved",
    refresh: "Refresh",
    prevYearBalance: "Previous year balance",
    prevYearCarryOver: "Year -1 carry over",
    days: "d",
    lastAbsences: "Last 5 absences",
    nextAbsences: "Next 5 absences",
    noPlannedAbsences: "No planned absences",
    deductedFromPrevYear: "Deducted from prev. year",
    fromN1: "from N-1",
    
    forCollaborator: "For collaborator",
    forMyself: "For myself",
    
    // Users
    userManagement: "User management",
    usersRegistered: "user(s) registered",
    newUser: "New user",
    collaborators: "Collaborators",
    managers: "Managers",
    active: "Active",
    inactive: "Inactive",
    name: "Name",
    role: "Role",
    director: "Director",
    manager: "Manager",
    editUser: "Edit user",
    createUser: "Create user",
    userCreated: "User created",
    userUpdated: "User updated",
    userDeleted: "User deleted",
    userActivated: "User activated",
    userDeactivated: "User deactivated",
    showInactiveUsers: "Show inactive users",
    
    // Stats
    statistics: "Statistics",
    teamPerformance: "Team performance analysis",
    thisWeek: "This week",
    thisMonth: "This month",
    thisYear: "This year",
    workHoursSummary: "WORK HOURS SUMMARY",
    months3: "3 months",
    months6: "6 months",
    totalHours: "Total hours",
    avgPerson: "Avg / Person",
    hoursByCollaborator: "Hours by collaborator",
    distribution: "Distribution (Top 5)",
    detailByCollaborator: "Detail by collaborator",
    hoursWorked: "Hours worked",
    daysWorked: "Days worked",
    percentTotal: "% of total",
    noDataAvailable: "No data available",
    verticalLayout: "Vertical layout",
    horizontalLayout: "Horizontal layout",
    
    // Totals
    weeklyTotal: "Weekly total",
    monthlyTotal: "Monthly total",
    mondayToSunday: "Monday - Sunday",
    calendarMonth: "Calendar month",
    day: "Day",
    
    // Events
    events: "Events",
    newEvent: "New event",
    eventTitle: "Title",
    eventDescription: "Description",
    eventColor: "Color",
    allDay: "All day",
    eventCreated: "Event created",
    eventUpdated: "Event updated",
    eventDeleted: "Event deleted",
    
    // Export
    exportPDF: "Export PDF",
    exportExcel: "Export Excel",
    exportSuccess: "Export downloaded successfully",
    exportError: "Export error",
    pdfExported: "PDF exported successfully",
    
    // Holidays
    holiday: "Holiday",
    
    // Password
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    passwordChanged: "Password changed",
    passwordMismatch: "Passwords do not match",
    forgotPassword: "Forgot password?",
    forgotPasswordDescription: "Enter your email and we'll send you a reset link.",
    sendResetLink: "Send reset link",
    resetEmailSent: "Email sent",
    emailSent: "Email sent!",
    checkYourEmail: "If an account exists with this address, you will receive an email with instructions.",
    backToLogin: "Back to login",
    
    // Colors
    userColor: "Color",
    
    // Overtime
    overtime: "Overtime",
    overtimeManagement: "Overtime management",
    addOvertime: "Add hours",
    overtimeHours: "Hours",
    overtimeReason: "Reason",
    overtimeDate: "Date",
    overtimeAdded: "Overtime added",
    overtimeDeleted: "Entry deleted",
    totalOvertime: "Total overtime",
    noOvertimeEntries: "No overtime entries",
    confirmDeleteOvertime: "Are you sure you want to delete this entry?",
    
    // Admin
    administration: "Administration",
    systemConfiguration: "System configuration",
    emailConfiguration: "Email configuration",
    brevoSmtpSettings: "Brevo SMTP settings for sending emails",
    databaseConfiguration: "Database configuration",
    mysqlSettings: "MySQL connection settings (OVH)",
    mysqlMigrationNote: "Migration to MySQL will be performed once settings are configured and validated.",
    smtpHost: "SMTP Server",
    smtpPort: "SMTP Port",
    smtpUser: "SMTP User",
    smtpPassword: "SMTP Password",
    emailFrom: "Sender email",
    mysqlHost: "MySQL Server",
    mysqlPort: "MySQL Port",
    mysqlDatabase: "Database",
    mysqlUser: "MySQL User",
    mysqlPassword: "MySQL Password",
    configSaved: "Configuration saved",
    testConnection: "Test connection",
    emailTestSuccess: "Email test successful",
    emailTestFailed: "Email test failed",
    connected: "Connected",
    failed: "Failed",
    testing: "Testing...",
    saving: "Saving...",
    note: "Note",
    
    // User preferences
    defaultLanguage: "Default language",
    
    // Filter & Selection
    filter: "Filter",
    filters: "Filters",
    selectCollaborators: "Select collaborators",
    selectAll: "All",
    deselectAll: "None",
    allCollaborators: "All collaborators",
    you: "you",
    more: "more",
    notAuthorized: "Not authorized",
    
    // Work Hours & Holidays
    workHours: "Work hours",
    workHoursConfiguration: "Work hours configuration",
    workHoursDescription: "Set the start and end hours for the schedule display",
    dayStartHour: "Start hour",
    dayEndHour: "End hour",
    workHoursNote: "These settings define the time range displayed in the schedule.",
    holidayCountry: "Holiday country",
    selectCountry: "Select country",
    switzerland: "Switzerland",
    france: "France",
    holidayCountryNote: "Public holidays will be displayed according to the selected country.",
    portalLanguage: "Portal language",
    defaultLanguage: "Default language",
    defaultDuration: "Default duration",
    defaultDayDuration: "Day duration",
    defaultBreakDuration: "Default break",
    breakThreshold: "Break threshold",
    breakThresholdDesc: "Hours after which a break is required",
    hours: "hours",
    minutes: "minutes",
    
    // My Profile
    myProfile: "My Profile",
    changeOwnPassword: "Change my password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    passwordChanged: "Password changed successfully",
    passwordMismatch: "Passwords do not match",
    incorrectCurrentPassword: "Current password incorrect",
    
    // Email Test
    testEmailConnection: "Test email connection",
    testEmailAddress: "Test email",
    sendTestEmail: "Send test",
    sending: "Sending...",
    enterTestEmail: "Enter a test email address",
    
    // Schedule extras
    breakMinutes: "Break (minutes)",
    comment: "Comment",
    commentPlaceholder: "Optional comment...",
    netHours: "Net hours",
    break: "Break",
    sourceWeek: "Source week",
    targetWeeks: "Target weeks",
    selectWeek: "Select a week",
    selected: "selected",
    selectTargetWeeks: "Select at least one target week",
    editEvent: "Edit event",
    
    // Reporting Planning
    reportingPlanning: "Reporting Planning",
    reportYourHours: "Report your worked hours",
    reportHours: "Report my hours",
    archived: "Archived",
    validatedWeeks: "Validated weeks",
    noArchivedWeeks: "No archived weeks",
    weekValidated: "This week has been validated",
    weekPendingValidation: "Pending validation by your manager",
    weekRejected: "This week has been rejected",
    selectPastWeek: "Select a past week to report your hours",
    noScheduleForWeek: "No schedule for this week",
    editHours: "Edit",
    modified: "Modified",
    unchanged: "Unchanged",
    submitForValidation: "Submit for validation",
    weekSubmitted: "Week submitted for validation",
    hoursSaved: "Hours saved",
    editActualHours: "Edit actual hours",
    optionalComment: "Optional comment (delay, unexpected...)",
    pendingValidations: "Pending validations",
    allReports: "All reports",
    noPendingValidations: "No pending validations",
    modifiedSlots: "Modified slots",
    approve: "Approve",
    reject: "Reject",
    reportApproved: "Report approved",
    reportRejected: "Report rejected",
    filters: "Filters",
    allStatuses: "All statuses",
    allCollaborators: "All collaborators",
    allDates: "All dates",
    clearDate: "Clear",
    noReportsFound: "No reports found",
    submittedOn: "Submitted on",
    validatedOn: "Validated on",
    validated: "Validated",
    
    // Working days calculation
    numberOfDays: "Days",
    effectiveDeduction: "Effective time deducted",
    calendarDays: "Calendar days",
    workingDays: "Working days",
    realDays: "Real days",
    deductedDays: "Deducted days",
    days: "day(s)",
    calculating: "Calculating",
    excludedDaysInfo: "Excluded: {{weekends}} weekend(s), {{holidays}} holiday(s)",
    
    // Multi-select
    selectAll: "Select all",
    deselectAll: "Deselect all",
    clearSelection: "Clear selection",
    
    // Profile
    chooseLanguage: "Choose my language",
    languageChanged: "Language changed",
    languageNote: "The chosen language will be used for the interface and PDF exports.",
    passwordMinLength: "Minimum 6 characters",
    passwordTooShort: "Password must be at least 6 characters",
    
    // Contractual Hours & Stats
    weeklyContractualHours: "Weekly contractual hours",
    weeklyContractualHoursRequired: "Weekly contractual hours are required",
    requiredField: "Required field",
    contractualHours: "Contractual hours",
    actualVsContractual: "Worked hours vs. contractual",
    variance: "Variance",
    overtime: "Overtime",
    undertime: "Undertime",
    sickDays: "Sick days",
    sickDaysUsed: "Sick days used",
    sickDaysRemaining: "Sick days remaining",
    
    // Dashboard Widget Preferences
    dashboardWidgets: "Dashboard widgets",
    showWeather: "Show weather",
    showNewsAltstaetten: "Show Altstätten news",
    showTennis: "Show tennis news",
    
    // Default Leave Days
    defaultLeaveDays: "Default leave days",
    
    // Leave Admin
    leaveManagement: "Leave Management",
    carryoverTitle: "Carryover Remaining Days",
    carryoverDescription: "Transfer remaining days from source year to target year's carryover.",
    carryoverButton: "Transfer remaining days to carryover",
    confirmCarryover: "Do you want to transfer remaining days from {{source}} to {{target}} carryover for all users?",
    resetQuotasTitle: "Reset Quotas",
    resetQuotasDescription: "Reset leave quotas based on each user's default leave days.",
    resetQuotasButton: "Reset quotas to defaults",
    resetQuotasInfo: "This action will create or update leave allocations for all active users using their default leave days.",
    confirmResetQuotas: "Do you want to reset quotas for year {{year}} for all users?",
    sourceYear: "Source year",
    targetYear: "Target year",
    totalUsers: "Total users",
    usersWithAllocation: "With allocation",
    usersWithoutAllocation: "Without allocation",
    leaveAllocationSummary: "Allocation Summary",
    defaultDays: "Default days",
    annualDays: "Annual days",
    carryoverDays: "Carryover N-1",
    totalDays: "Total days",
    
    // Day part for absences
    dayPart: "Day part",
    morning: "Morning",
    afternoon: "Afternoon",
    fullDay: "Full day",
    
    // Version
    version: "Version",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    close: "Close",
    edit: "Edit",
    hour: "Hour",
    hours: "hours",
    h: "h",
    days: "days",
    day: "day",
    week: "Week",
    month: "Month",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    sunday: "Sun",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    
    // Team Communication
    teamCommunication: "Team Communication",
    sendMessageToTeam: "Send a message to your team",
    recipients: "Recipients",
    selectAllTeam: "All team",
    recipientsSelected: "recipient(s) selected",
    subject: "Subject",
    enterSubject: "Enter message subject",
    message: "Message",
    enterMessage: "Write your message...",
    attachPlanningPDF: "Attach planning PDF",
    planningDuration: "Planning duration",
    weeks: "weeks",
    sendMessage: "Send message",
    sending: "Sending",
    messageSentTo: "Message sent to",
    selectAtLeastOneRecipient: "Select at least one recipient",
    subjectRequired: "Subject is required",
    messageRequired: "Message is required",
    sendError: "Error sending message",
    messageHistory: "Message history",
    noMessagesSent: "No messages sent",
    failed: "failed",
    dragToMove: "Drag to move",
    
    // Navigation extras
    publicSite: "Public site",
    help: "Help",
    
    // Error Log & Version
    errorLog: "Error Log",
    hideResolved: "Hide resolved",
    showResolved: "Show resolved",
    resolveAll: "Resolve all",
    clearAll: "Clear all",
    noErrors: "No errors",
    version: "Version",
    
    // Schedule Period Selector
    displayPeriod: "Display",
    weeksFrom: "week(s) from",
    monthsFrom: "month(s) from",
    today: "Today",
    
    // Daily Planning Validation
    validateMyPlanning: "Validate my planning",
    dailyValidation: "Daily validation",
    pendingValidationDays: "days pending validation",
    noValidationPending: "No days pending validation",
    conformSchedule: "Schedule is correct",
    nonConformSchedule: "Propose modification",
    validateDay: "Validate",
    validateAll: "Validate all",
    modifySchedule: "Modify",
    effectiveTime: "Effective time",
    modificationReason: "Modification reason",
    reasonRequired: "Reason is required",
    submitModification: "Submit modification",
    modificationSubmitted: "Modification submitted",
    validationHistory: "Validation history",
    noValidationHistory: "No history",
    modificationApproved: "Approved",
    modificationRejected: "Rejected",
    modificationPending: "Pending",
    dayValidated: "Day validated",
    allDaysValidated: "All days have been validated",
    proposedStart: "Proposed start",
    proposedEnd: "Proposed end",
    proposedBreak: "Proposed break",
    
    // Manager Planning Validation
    collaboratorsToValidate: "Collaborators to validate",
    collaboratorsWithPendingDays: "Collaborators with more than 2 days to validate",
    planningValidation: "Planning validation",
    daysToValidate: "days",
    stateFilter: "State",
    toValidate: "To validate",
    modifiedState: "Modified",
    notModifiedState: "Not modified",
    allStates: "All states",
    dateRange: "Date range",
    fromDate: "From",
    toDate: "To",
    originalPlanning: "Original planning",
    proposedModification: "Proposed modification",
    approveModification: "Approve",
    rejectModification: "Reject",
    modificationApprovedSuccess: "Modification approved and applied to planning",
    modificationRejectedSuccess: "Modification rejected",
    noValidationsToReview: "No validations pending",
    scheduleModified: "Modified",
  },
  
  de: {
    // Navigation
    dashboard: "Dashboard",
    schedule: "Planung",
    absences: "Urlaub / Abwesenheiten",
    users: "Benutzer",
    team: "Mein Team",
    stats: "Statistiken",
    logout: "Abmelden",
    
    // Login
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    firstName: "Vorname",
    lastName: "Nachname",
    signIn: "Anmelden",
    signUp: "Registrieren",
    noAccount: "Noch kein Konto? Registrieren",
    hasAccount: "Bereits ein Konto? Anmelden",
    accessWorkspace: "zu Ihrem Vitalis - Sports Mitarbeiter-Extranet",
    createAccount: "Erstellen Sie Ihr Konto",
    loginSuccess: "Anmeldung erfolgreich",
    
    // Dashboard
    welcomeBack: "Willkommen",
    yourSummary: "Hier ist Ihre Übersicht",
    hoursThisWeek: "Stunden diese Woche",
    hoursThisMonth: "Stunden diesen Monat",
    pendingAbsences: "Ausstehende Abwesenheiten",
    approvedAbsences: "Genehmigte Abwesenheiten",
    teamStats: "Team-Statistiken",
    teamMembers: "Teammitglieder",
    totalHoursMonth: "Gesamtstunden (Monat)",
    avgPerPerson: "Durchschnitt pro Person",
    hoursPerCollaborator: "Stunden pro Mitarbeiter (diesen Monat)",
    quickActions: "Schnellaktionen",
    viewSchedule: "Planung anzeigen",
    manageAbsences: "Abwesenheiten verwalten",
    requestAbsence: "Abwesenheit beantragen",
    
    // Schedule
    weekOf: "Woche vom",
    dayView: "Tag",
    weekView: "Woche",
    monthView: "Monat",
    previousDay: "Vorheriger Tag",
    nextDay: "Nächster Tag",
    copyWeek: "Kopieren",
    allMembers: "Alle Mitglieder",
    addSlot: "Zeitfenster hinzufügen",
    editSlot: "Zeitfenster bearbeiten",
    slotAdded: "Zeitfenster hinzugefügt",
    slotUpdated: "Zeitfenster aktualisiert",
    slotDeleted: "Zeitfenster gelöscht",
    collaborator: "Mitarbeiter",
    date: "Datum",
    startTime: "Beginn",
    endTime: "Ende",
    add: "Hinzufügen",
    update: "Aktualisieren",
    delete: "Löschen",
    copySchedule: "Planung kopieren",
    copyConfirm: "Aktuelle Wochenplanung zur nächsten Woche kopieren?",
    source: "Quelle",
    destination: "Ziel",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    slotsCopied: "Zeitfenster kopiert",
    resizeSlot: "Slot vergrössern/verkleinern",
    addSlot: "Slot hinzufügen",
    
    // Time corrections
    actualHours: "Tatsächliche Stunden",
    plannedHours: "Geplante Stunden",
    difference: "Differenz",
    pendingCorrections: "Ausstehende Korrekturen",
    correctTime: "Zeit korrigieren",
    actualStartTime: "Tatsächliche Startzeit",
    actualEndTime: "Tatsächliche Endzeit",
    correctionReason: "Korrekturgrund",
    submitCorrection: "Korrektur einreichen",
    validateCorrection: "Korrektur validieren",
    rejectCorrection: "Korrektur ablehnen",
    correctionSubmitted: "Korrektur eingereicht",
    correctionValidated: "Korrektur validiert",
    correctionRejected: "Korrektur abgelehnt",
    
    // Absences
    absenceRequests: "Abwesenheitsanträge",
    myAbsences: "Meine Abwesenheiten",
    requestsPending: "ausstehende(r) Antrag/Anträge",
    manageYourAbsences: "Verwalten Sie Ihre Abwesenheitsanträge",
    newRequest: "Neuer Antrag",
    noAbsences: "Keine Abwesenheitsanträge",
    type: "Typ",
    period: "Zeitraum",
    reason: "Grund",
    status: "Status",
    actions: "Aktionen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    cancelled: "Storniert",
    cancel: "Stornieren",
    requestCancelled: "Antrag storniert",
    confirmCancelAbsence: "Sind Sie sicher, dass Sie diese Abwesenheit stornieren möchten?",
    cancelledByAdmin: "Vom Administrator storniert",
    paidLeave: "Bezahlter Urlaub",
    sickLeave: "Krankheit",
    unpaidLeave: "Unbezahlter Urlaub",
    other: "Sonstiges",
    newAbsenceRequest: "Neuer Abwesenheitsantrag",
    absenceType: "Abwesenheitstyp",
    startDate: "Startdatum",
    endDate: "Enddatum",
    reasonPlaceholder: "Beschreiben Sie den Grund für Ihre Abwesenheit...",
    submitRequest: "Antrag einreichen",
    requestCreated: "Abwesenheitsantrag erstellt",
    processRequest: "Antrag bearbeiten",
    rejectionReason: "Ablehnungsgrund (optional)",
    rejectionPlaceholder: "Geben Sie den Grund bei Ablehnung an...",
    approve: "Genehmigen",
    reject: "Ablehnen",
    requestApproved: "Antrag genehmigt",
    requestRejected: "Antrag abgelehnt",
    
    // Leave balance
    leaveBalance: "Urlaubssaldo",
    leaveBalanceDescription: "Urlaubsverfolgung pro Mitarbeiter für das laufende Jahr",
    annualLeave: "Jahresurlaub",
    usedLeave: "Verbraucht",
    pendingLeave: "Ausstehend",
    remainingLeave: "Verbleibend",
    hoursAllocated: "Zugeteilte Stunden",
    hoursUsed: "Verbrauchte Stunden",
    hoursPlanned: "Geplante Stunden",
    hoursRemaining: "Verbleibende Stunden",
    daysAllocated: "Zugeteilte Tage",
    daysUsed: "Genehmigte Tage",
    daysPlanned: "Tage ausstehend",
    daysRemaining: "Verbleibende Tage",
    totalAvailable: "Gesamt verfügbar",
    noAllocationYet: "Keine Urlaubszuteilung für dieses Jahr. Klicken Sie auf 'Urlaub zuteilen', um eine zu erstellen.",
    allocateLeave: "Urlaub zuteilen",
    year: "Jahr",
    week: "Wo",
    allocatedHours: "Zugeteilte Stunden",
    saveAllocation: "Speichern",
    allocationSaved: "Zuteilung gespeichert",
    refresh: "Aktualisieren",
    prevYearBalance: "Übertrag Vorjahr",
    prevYearCarryOver: "Restguthaben Jahr -1",
    days: "T",
    lastAbsences: "Letzte 5 Abwesenheiten",
    nextAbsences: "Nächste 5 Abwesenheiten",
    noPlannedAbsences: "Keine geplanten Abwesenheiten",
    deductedFromPrevYear: "Von Vorjahr abgezogen",
    fromN1: "davon N-1",
    
    forCollaborator: "Für Mitarbeiter",
    forMyself: "Für mich selbst",
    
    // Users
    userManagement: "Benutzerverwaltung",
    usersRegistered: "registrierte(r) Benutzer",
    newUser: "Neuer Benutzer",
    collaborators: "Mitarbeiter",
    managers: "Manager",
    active: "Aktiv",
    inactive: "Inaktiv",
    name: "Name",
    role: "Rolle",
    director: "Direktor",
    manager: "Manager",
    editUser: "Benutzer bearbeiten",
    createUser: "Benutzer erstellen",
    userCreated: "Benutzer erstellt",
    userUpdated: "Benutzer aktualisiert",
    userDeleted: "Benutzer gelöscht",
    userActivated: "Benutzer aktiviert",
    userDeactivated: "Benutzer deaktiviert",
    showInactiveUsers: "Inaktive Benutzer anzeigen",
    
    // Stats
    statistics: "Statistiken",
    teamPerformance: "Team-Leistungsanalyse",
    thisWeek: "Diese Woche",
    thisMonth: "Diesen Monat",
    thisYear: "Dieses Jahr",
    workHoursSummary: "ARBEITSSTUNDEN ÜBERSICHT",
    months3: "3 Monate",
    months6: "6 Monate",
    totalHours: "Gesamtstunden",
    avgPerson: "Durchschn. / Person",
    hoursByCollaborator: "Stunden pro Mitarbeiter",
    distribution: "Verteilung (Top 5)",
    detailByCollaborator: "Detail pro Mitarbeiter",
    hoursWorked: "Geleistete Stunden",
    daysWorked: "Arbeitstage",
    percentTotal: "% der Gesamtmenge",
    noDataAvailable: "Keine Daten verfügbar",
    verticalLayout: "Vertikale Ansicht",
    horizontalLayout: "Horizontale Ansicht",
    
    // Totals
    weeklyTotal: "Wochensumme",
    monthlyTotal: "Monatssumme",
    mondayToSunday: "Montag - Sonntag",
    calendarMonth: "Kalendermonat",
    day: "Tag",
    
    // Events
    events: "Ereignisse",
    newEvent: "Neues Ereignis",
    eventTitle: "Titel",
    eventDescription: "Beschreibung",
    eventColor: "Farbe",
    allDay: "Ganztägig",
    eventCreated: "Ereignis erstellt",
    eventUpdated: "Ereignis aktualisiert",
    eventDeleted: "Ereignis gelöscht",
    
    // Export
    exportPDF: "PDF exportieren",
    exportExcel: "Excel exportieren",
    exportSuccess: "Export erfolgreich heruntergeladen",
    exportError: "Exportfehler",
    pdfExported: "PDF erfolgreich exportiert",
    
    // Holidays
    holiday: "Feiertag",
    
    // Password
    changePassword: "Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordChanged: "Passwort geändert",
    passwordMismatch: "Passwörter stimmen nicht überein",
    forgotPassword: "Passwort vergessen?",
    forgotPasswordDescription: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen.",
    sendResetLink: "Link senden",
    resetEmailSent: "E-Mail gesendet",
    emailSent: "E-Mail gesendet!",
    checkYourEmail: "Wenn ein Konto mit dieser Adresse existiert, erhalten Sie eine E-Mail mit Anweisungen.",
    backToLogin: "Zurück zur Anmeldung",
    
    // Colors
    userColor: "Farbe",
    
    // Overtime
    overtime: "Überstunden",
    overtimeManagement: "Überstundenverwaltung",
    addOvertime: "Stunden hinzufügen",
    overtimeHours: "Stunden",
    overtimeReason: "Grund",
    overtimeDate: "Datum",
    overtimeAdded: "Überstunden hinzugefügt",
    overtimeDeleted: "Eintrag gelöscht",
    totalOvertime: "Überstunden gesamt",
    noOvertimeEntries: "Keine Überstundeneinträge",
    confirmDeleteOvertime: "Möchten Sie diesen Eintrag wirklich löschen?",
    
    // Admin
    administration: "Administration",
    systemConfiguration: "Systemkonfiguration",
    emailConfiguration: "E-Mail-Konfiguration",
    brevoSmtpSettings: "Brevo SMTP-Einstellungen für den E-Mail-Versand",
    databaseConfiguration: "Datenbankkonfiguration",
    mysqlSettings: "MySQL-Verbindungseinstellungen (OVH)",
    mysqlMigrationNote: "Die Migration zu MySQL wird durchgeführt, sobald die Einstellungen konfiguriert und validiert sind.",
    smtpHost: "SMTP-Server",
    smtpPort: "SMTP-Port",
    smtpUser: "SMTP-Benutzer",
    smtpPassword: "SMTP-Passwort",
    emailFrom: "Absender-E-Mail",
    mysqlHost: "MySQL-Server",
    mysqlPort: "MySQL-Port",
    mysqlDatabase: "Datenbank",
    mysqlUser: "MySQL-Benutzer",
    mysqlPassword: "MySQL-Passwort",
    configSaved: "Konfiguration gespeichert",
    testConnection: "Verbindung testen",
    emailTestSuccess: "E-Mail-Test erfolgreich",
    emailTestFailed: "E-Mail-Test fehlgeschlagen",
    connected: "Verbunden",
    failed: "Fehlgeschlagen",
    testing: "Teste...",
    saving: "Speichert...",
    note: "Hinweis",
    
    // User preferences
    defaultLanguage: "Standardsprache",
    
    // Filter & Selection
    filter: "Filter",
    filters: "Filter",
    selectCollaborators: "Mitarbeiter auswählen",
    selectAll: "Alle",
    deselectAll: "Keine",
    allCollaborators: "Alle Mitarbeiter",
    you: "Sie",
    more: "mehr",
    notAuthorized: "Nicht autorisiert",
    
    // Work Hours & Holidays
    workHours: "Arbeitszeiten",
    workHoursConfiguration: "Arbeitszeitenkonfiguration",
    workHoursDescription: "Legen Sie die Start- und Endzeit für die Planungsanzeige fest",
    dayStartHour: "Startzeit",
    dayEndHour: "Endzeit",
    workHoursNote: "Diese Einstellungen definieren den im Zeitplan angezeigten Zeitraum.",
    holidayCountry: "Land für Feiertage",
    selectCountry: "Land auswählen",
    switzerland: "Schweiz",
    france: "Frankreich",
    holidayCountryNote: "Die Feiertage werden entsprechend dem ausgewählten Land angezeigt.",
    portalLanguage: "Portalsprache",
    defaultLanguage: "Standardsprache",
    defaultDuration: "Standarddauer",
    defaultDayDuration: "Tagesdauer",
    defaultBreakDuration: "Standardpause",
    breakThreshold: "Pausenschwelle",
    breakThresholdDesc: "Stunden, nach denen eine Pause erforderlich ist",
    hours: "Stunden",
    minutes: "Minuten",
    
    // My Profile
    myProfile: "Mein Profil",
    changeOwnPassword: "Mein Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordChanged: "Passwort erfolgreich geändert",
    passwordMismatch: "Passwörter stimmen nicht überein",
    incorrectCurrentPassword: "Aktuelles Passwort falsch",
    
    // Email Test
    testEmailConnection: "E-Mail-Verbindung testen",
    testEmailAddress: "Test-E-Mail",
    sendTestEmail: "Test senden",
    sending: "Sende...",
    enterTestEmail: "Geben Sie eine Test-E-Mail-Adresse ein",
    
    // Schedule extras
    breakMinutes: "Pause (Minuten)",
    comment: "Kommentar",
    commentPlaceholder: "Optionaler Kommentar...",
    netHours: "Netto Stunden",
    break: "Pause",
    sourceWeek: "Quellwoche",
    targetWeeks: "Zielwochen",
    selectWeek: "Woche auswählen",
    selected: "ausgewählt",
    selectTargetWeeks: "Wählen Sie mindestens eine Zielwoche",
    editEvent: "Ereignis bearbeiten",
    
    // Reporting Planning
    reportingPlanning: "Reporting Planning",
    reportYourHours: "Melden Sie Ihre geleisteten Stunden",
    reportHours: "Meine Stunden melden",
    archived: "Archiviert",
    validatedWeeks: "Validierte Wochen",
    noArchivedWeeks: "Keine archivierten Wochen",
    weekValidated: "Diese Woche wurde validiert",
    weekPendingValidation: "Warten auf Validierung durch Ihren Manager",
    weekRejected: "Diese Woche wurde abgelehnt",
    selectPastWeek: "Wählen Sie eine vergangene Woche, um Ihre Stunden zu melden",
    noScheduleForWeek: "Kein Zeitplan für diese Woche",
    editHours: "Bearbeiten",
    modified: "Geändert",
    unchanged: "Unverändert",
    submitForValidation: "Zur Validierung einreichen",
    weekSubmitted: "Woche zur Validierung eingereicht",
    hoursSaved: "Stunden gespeichert",
    editActualHours: "Tatsächliche Stunden bearbeiten",
    optionalComment: "Optionaler Kommentar (Verspätung, Unvorhergesehenes...)",
    pendingValidations: "Ausstehende Validierungen",
    allReports: "Alle Berichte",
    noPendingValidations: "Keine ausstehenden Validierungen",
    modifiedSlots: "Geänderte Zeitfenster",
    approve: "Genehmigen",
    reject: "Ablehnen",
    reportApproved: "Bericht genehmigt",
    reportRejected: "Bericht abgelehnt",
    filters: "Filter",
    allStatuses: "Alle Status",
    allCollaborators: "Alle Mitarbeiter",
    allDates: "Alle Daten",
    clearDate: "Löschen",
    noReportsFound: "Keine Berichte gefunden",
    submittedOn: "Eingereicht am",
    validatedOn: "Validiert am",
    validated: "Validiert",
    
    // Working days calculation
    numberOfDays: "Tage",
    effectiveDeduction: "Effektive abgezogene Zeit",
    calendarDays: "Kalendertage",
    workingDays: "Arbeitstage",
    realDays: "Reale Tage",
    deductedDays: "Abgezogene Tage",
    days: "Tag(e)",
    calculating: "Berechnung",
    excludedDaysInfo: "Ausgeschlossen: {{weekends}} Wochenende(n), {{holidays}} Feiertag(e)",
    
    // Multi-select
    selectAll: "Alle auswählen",
    deselectAll: "Alle abwählen",
    clearSelection: "Auswahl löschen",
    
    // Contractual Hours & Stats
    weeklyContractualHours: "Vertragsstunden/Woche",
    weeklyContractualHoursRequired: "Wöchentliche Vertragsstunden sind erforderlich",
    requiredField: "Pflichtfeld",
    contractualHours: "Vertragsstunden",
    actualVsContractual: "Geleistete Stunden vs. Vertraglich",
    variance: "Abweichung",
    overtime: "Überstunden",
    undertime: "Fehlende Stunden",
    sickDays: "Krankheitstage",
    sickDaysUsed: "Krankheitstage verbraucht",
    sickDaysRemaining: "Krankheitstage übrig",
    
    // Dashboard Widget Preferences
    dashboardWidgets: "Dashboard-Widgets",
    showWeather: "Wetter anzeigen",
    showNewsAltstaetten: "Altstätten-News anzeigen",
    showTennis: "Tennis-News anzeigen",
    
    // Default Leave Days
    defaultLeaveDays: "Standard-Urlaubstage",
    
    // Leave Admin
    leaveManagement: "Urlaubsverwaltung",
    carryoverTitle: "Resturlaub übertragen",
    carryoverDescription: "Übertragen Sie die verbleibenden Tage vom Quelljahr auf den Übertrag des Zieljahres.",
    carryoverButton: "Resttage als Übertrag übertragen",
    confirmCarryover: "Möchten Sie die Resttage von {{source}} auf den Übertrag {{target}} für alle Benutzer übertragen?",
    resetQuotasTitle: "Kontingente zurücksetzen",
    resetQuotasDescription: "Setzen Sie die Urlaubskontingente basierend auf den Standard-Urlaubstagen jedes Benutzers zurück.",
    resetQuotasButton: "Kontingente auf Standard zurücksetzen",
    resetQuotasInfo: "Diese Aktion erstellt oder aktualisiert die Urlaubszuweisungen für alle aktiven Benutzer unter Verwendung ihrer Standard-Urlaubstage.",
    confirmResetQuotas: "Möchten Sie die Kontingente für das Jahr {{year}} für alle Benutzer zurücksetzen?",
    sourceYear: "Quelljahr",
    targetYear: "Zieljahr",
    totalUsers: "Benutzer gesamt",
    usersWithAllocation: "Mit Zuweisung",
    usersWithoutAllocation: "Ohne Zuweisung",
    leaveAllocationSummary: "Zuweisungsübersicht",
    defaultDays: "Standardtage",
    annualDays: "Jahrestage",
    carryoverDays: "Übertrag N-1",
    totalDays: "Tage gesamt",
    
    // Day part for absences
    dayPart: "Tageszeit",
    morning: "Vormittag",
    afternoon: "Nachmittag",
    fullDay: "Ganzer Tag",
    
    // Version
    version: "Version",
    
    // Common
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    save: "Speichern",
    close: "Schliessen",
    edit: "Bearbeiten",
    hour: "Stunde",
    hours: "Stunden",
    h: "Std",
    days: "Tage",
    day: "Tag",
    week: "Woche",
    month: "Monat",
    monday: "Mo",
    tuesday: "Di",
    wednesday: "Mi",
    thursday: "Do",
    friday: "Fr",
    saturday: "Sa",
    sunday: "So",
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
    
    // Team Communication
    teamCommunication: "Teamkommunikation",
    sendMessageToTeam: "Senden Sie eine Nachricht an Ihr Team",
    recipients: "Empfänger",
    selectAllTeam: "Gesamtes Team",
    recipientsSelected: "Empfänger ausgewählt",
    subject: "Betreff",
    enterSubject: "Betreff eingeben",
    message: "Nachricht",
    enterMessage: "Schreiben Sie Ihre Nachricht...",
    attachPlanningPDF: "Planung als PDF anhängen",
    planningDuration: "Planungsdauer",
    weeks: "Wochen",
    sendMessage: "Nachricht senden",
    sending: "Wird gesendet",
    messageSentTo: "Nachricht gesendet an",
    selectAtLeastOneRecipient: "Wählen Sie mindestens einen Empfänger",
    subjectRequired: "Betreff ist erforderlich",
    messageRequired: "Nachricht ist erforderlich",
    sendError: "Fehler beim Senden",
    messageHistory: "Nachrichtenverlauf",
    noMessagesSent: "Keine Nachrichten gesendet",
    failed: "fehlgeschlagen",
    dragToMove: "Ziehen zum Verschieben",
    
    // Navigation extras
    publicSite: "Öffentliche Webseite",
    help: "Hilfe",
    
    // Error Log & Version
    errorLog: "Fehlerprotokoll",
    hideResolved: "Gelöste ausblenden",
    showResolved: "Gelöste anzeigen",
    resolveAll: "Alle lösen",
    clearAll: "Alle löschen",
    noErrors: "Keine Fehler",
    version: "Version",
    
    // Schedule Period Selector
    displayPeriod: "Anzeigen",
    weeksFrom: "Woche(n) ab",
    monthsFrom: "Monat(e) ab",
    today: "Heute",
    
    // Daily Planning Validation
    validateMyPlanning: "Meine Planung validieren",
    dailyValidation: "Tägliche Validierung",
    pendingValidationDays: "Tage ausstehend zur Validierung",
    noValidationPending: "Keine Tage ausstehend zur Validierung",
    conformSchedule: "Planung ist korrekt",
    nonConformSchedule: "Änderung vorschlagen",
    validateDay: "Validieren",
    validateAll: "Alle validieren",
    modifySchedule: "Ändern",
    effectiveTime: "Effektive Zeit",
    modificationReason: "Änderungsgrund",
    reasonRequired: "Grund ist erforderlich",
    submitModification: "Änderung einreichen",
    modificationSubmitted: "Änderung eingereicht",
    validationHistory: "Validierungsverlauf",
    noValidationHistory: "Kein Verlauf",
    modificationApproved: "Genehmigt",
    modificationRejected: "Abgelehnt",
    modificationPending: "Ausstehend",
    dayValidated: "Tag validiert",
    allDaysValidated: "Alle Tage wurden validiert",
    proposedStart: "Vorgeschlagener Beginn",
    proposedEnd: "Vorgeschlagenes Ende",
    proposedBreak: "Vorgeschlagene Pause",
    
    // Manager Planning Validation
    collaboratorsToValidate: "Mitarbeiter zu validieren",
    collaboratorsWithPendingDays: "Mitarbeiter mit mehr als 2 Tagen zu validieren",
    planningValidation: "Planungsvalidierung",
    daysToValidate: "Tage",
    stateFilter: "Status",
    toValidate: "Zu validieren",
    modifiedState: "Geändert",
    notModifiedState: "Nicht geändert",
    allStates: "Alle Status",
    dateRange: "Zeitraum",
    fromDate: "Von",
    toDate: "Bis",
    originalPlanning: "Originalplanung",
    proposedModification: "Vorgeschlagene Änderung",
    approveModification: "Genehmigen",
    rejectModification: "Ablehnen",
    modificationApprovedSuccess: "Änderung genehmigt und auf Planung angewendet",
    modificationRejectedSuccess: "Änderung abgelehnt",
    noValidationsToReview: "Keine Validierungen ausstehend",
    scheduleModified: "Geändert",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.fr[key] || key;
};
